import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const RecordingStopIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <rect height="15" rx="7.5" stroke="currentColor" width="15" x="0.5" y="0.5" />
    <rect fill="currentColor" height="5" stroke="currentColor" width="5" x="5.5" y="5.5" />
  </svg>
);
